import { alphanumericRegex } from 'shell/constants/regex';
import * as yup from 'yup';

export const validationSchema = yup.object({
  filter: yup
    .object()
    .nullable()
    .shape({
      code: yup.string().nullable().matches(alphanumericRegex, 'Il campo è alfanumerico'),
      description: yup.string().nullable().matches(alphanumericRegex, 'Il campo è alfanumerico'),
    }),
});
